import { loadDiagramFromRTDB } from '@diagram/service/diagram.rtdb';
import { LoaderFunctionArgs } from 'react-router-dom';

export async function diagramLoader({ params }: LoaderFunctionArgs) {
  const { id } = params;

  return await loadDiagramFromRTDB(id!);
}
